import { transform } from 'ol/proj'
import proj4 from 'proj4'

const domain = process.env.MIX_IMAGE_ENDPOINT

proj4.defs('EPSG:3006', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')

export const getImageUrlForKey = (key, width, height, fit = 'cover') => {
  const request = {
    bucket: process.env.MIX_AWS_BUCKET, // S3 bucket name
    key, // path to your file on the S3 bucket (ex. photos/face1.png)
    edits: {
      // smartCrop: true, // uncomment to crop around first face, will return nothing if no face is found
      // normalize: true,
      // grayscale: true,
      // sharpen: true,
      // blur: 5,
      // rotate: 0,
      resize: {
        width,
        height,
        fit
      }
    }
  }
  const strRequest = JSON.stringify(request)
  const encRequest = btoa(strRequest)
  const url = `${domain}/${encRequest}` // the image url

  return url
}

export const calculateXYZ = (lat = 59.63036395, lon = 16.646187055145276, zoom = 12) => {
  function long2tile (lon, zoom) { return (Math.floor((lon + 180) / 360 * Math.pow(2, zoom))) }
  function lat2tile (lat, zoom) { return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom))) }

  const z = zoom
  const x = long2tile(parseFloat(lon), zoom)
  const y = lat2tile(parseFloat(lat), zoom)

  return `https://api.lantmateriet.se/open/topowebb-ccby/v1/wmts/token/fe56356f-6700-3645-84c5-e803aef6d769/1.0.0/topowebb_nedtonad/default/3857/${z}/${y}/${x}.png`
}

export const scrollListener = store => {
  const setScrollPosInStore = _.debounce(() => {
    store.dispatch('setScrollPos', window.scrollY)
  }, 250, {
    leading: true,
    trailing: true
  })

  document.addEventListener('scroll', (evt) => {
    setScrollPosInStore()
  }, { capture: false, passive: true })
}

export const transformCoordinates = coordinates => transform(coordinates, 'EPSG:4326', 'EPSG:3857')

export const setupGeoJson = (locations, addressLocations) => {
  const locationFeatures = _.map(locations, location => ({
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: transform([location.longitude, location.latitude], 'EPSG:4326', 'EPSG:3857')
    },
    properties: {
      id: location.id,
      titel: location.title,
      resource_url: location.resource_url
    }
  }))

  const adressFeatures = addressLocations ? _.map(addressLocations.features, feature => ({
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: proj4('EPSG:3006', 'EPSG:3857', _.get(feature, 'properties.adressplatsattribut.adressplatspunkt.coordinates'))
    },
    properties: {
      id: feature.id,
      titel: `${_.get(feature, 'properties.adressomrade.faststalltNamn')}
      ${_.get(feature, 'properties.adressplatsattribut.adressplatsbeteckning.adressplatsnummer')}
      ${_.get(feature, 'properties.adressplatsattribut.postnummer')}
      ${_.get(feature, 'properties.adressplatsattribut.postort')}`
    }
  })) : []

  return {
    type: 'FeatureCollection',
    features: [
      ...locationFeatures,
      ...adressFeatures
    ]
  }
}

export const getValueFromObservable = input => JSON.parse(JSON.stringify(input))

export const getLinkHref = path => process.env.NODE_ENV === 'development' ? path : `/databas${path}`

export const getUrl = url => _.replace(`${process.env.MIX_ASSET_URL}/${url}`, '//', '/')
